import { PATH } from "constants/path"
import { pushTo } from "helpers/history"
import { MENU_TAB_ACCESS_KEY } from "../address-book.type"
import RoleUsersCard from "pages/projects/molecules/RoleUsersCard"
import { GetUsersInProjectProp } from "pages/project-component/types"

interface Props {
  project: {
    id: string
    code: string
    name: string
    role_users: GetUsersInProjectProp[]
  }
  projectIdActive: {
    setValue: (value: string) => void
    value: string
  }
}
export const ProjectItemCard = (props: Props) => {
  const { project, projectIdActive } = props

  const handleSelectProject = (projectId: string) => () => {
    if (projectIdActive.value === projectId) return
    pushTo(PATH.accessKey, undefined, undefined, {
      tab: MENU_TAB_ACCESS_KEY.PROJECT,
      projectId,
    })
    projectIdActive.setValue(projectId)
  }
  return (
    <div
      onClick={handleSelectProject(project.id)}
      key={project.id}
      className={`hover-project-card p-3 bg-white border border-[#e4e4e4] rounded-[6px] cursor-pointer flex flex-col gap-2 ${
        projectIdActive.value === project.id ? "active-project-build" : ""
      }`}
    >
      <span className="font-medium text-[12px] leading-[18px] text-[#7a7a7a]">
        {project.code}
      </span>
      <p className="font-semibold name-card text-[14px] leading-[24px] text-[#111111]">
        {project.name}
      </p>
      <div className="flex items-center flex-wrap gap-2">
        <RoleUsersCard data={project.role_users} max={5} />
      </div>
    </div>
  )
}
